// extracted by mini-css-extract-plugin
export default {"Contact":"Contact-module--Contact--nduJA","Description":"Contact-module--Description--3z8yc"};